<sc-sub-title><sc-dictionary-label
    dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.tasks-title"></sc-dictionary-label></sc-sub-title>
<sc-content-spacer vertical></sc-content-spacer>
<sc-no-data compact *ngIf="tasks == null || tasks.length === 0"></sc-no-data>
<ng-container *ngFor="let task of tasks; let i = index">
  <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
  <app-task-item [task]="task" [transportId]="transportId" (changed)="handleTaskItemChanged($event)"></app-task-item>
</ng-container>
